<template>
    <div>
        <!-- <LocalApplicationModule> -->
        <div>
            <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
                {{ moduleTitle }}
            </ModuleTitleNav>
            <div class="section-line" />
            <!-- <fieldset :disabled="formDisabled"> -->
            <fieldset :disabled="formDisabled">
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            In the boxes below for each indicator that has an Improvement Plan
                            Status Year greater than 0 please address the following:
                        </div>
                        <ul class="listA">
                            <li>
                                Provide an update of the Student Performance
                                Analysis Findings from the Comprehensive Needs Assessment
                                of the performance gaps that exist in subgroups
                            </li>
                            <li>
                                Describe the actions you will take to address
                                these gaps to continually make meaningful progress
                            </li>
                            <li>
                                Identify areas (specific tabs) of the Local Application
                                you have edited this year to address your improvement
                                plan status that will assist state staff in evaluating
                                your Improvement Plan (if any)
                            </li>
                        </ul>
                    </b-col>
                </b-form-row>
                <div class="dotted-rule" />
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            When addressing the items above be sure to keep in mind the following:
                        </div>
                        <ul class="listA">
                            <li>
                                Involve the appropriate stakeholders during the
                                analysis of information and possible actions to be taken
                            </li>
                            <li>
                                It must be implemented in the following academic year
                            </li>
                            <li>
                                It must be addressed prior to any addition or modification of existing Focus Areas
                            </li>
                            <li>
                                You cannot adjust your performance targets while in improvement status
                            </li>
                            <li>
                                It is required to be approved prior to creating your Annual Plan for the upcoming AY
                            </li>
                        </ul>
                    </b-col>
                </b-form-row>
                <div class="section-line" />
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Core Indicator Performance Targets
                        </div>
                        <b-table
                            :items="applicationPerkinsPerformance"
                            striped
                            small
                            bordered
                            :fields="coreIndicatorTable"
                            :disabled="formDisabled"
                            @saveForm="saveForm"
                        >
                            <template v-slot:cell(indicatorDisplayName)="data">
                                {{ data.item.indicatorDisplayName }}
                            </template>

                            <template v-slot:cell(priorPerformance)="data">
                                {{ (data.item.priorPerformance + '%') || 'Loading...' }}
                            </template>

                            <template v-slot:cell(target)="data">
                                {{ (data.item['targetAy' + targetAy] + '%') || 'Loading...' }}
                            </template>

                            <template v-slot:cell(improvementPlanYear)="data">
                                {{ data.item.improvementPlanYear }}
                            </template>
                        </b-table>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            1P1: Retention & Placement
                        </div>
                        <b-form-textarea
                            v-model="explanation1P1"
                            :disabled="formDisabled || explanation1P1Disabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            2P1: Credential Attainment
                        </div>
                        <b-form-textarea
                            v-model="explanation2P1"
                            :disabled="formDisabled || explanation2P1Disabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            3P1: Non-traditional Participation
                        </div>
                        <b-form-textarea
                            v-model="explanation3P1"
                            :disabled="formDisabled || explanation3P1Disabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
            </fieldset>
        </div>
        <!-- <div class="dotted-rule"></div> -->
        <div>
            <b-form-row>
                <b-col>
                    <LocalApplicationModuleActions
                        :is-loading="isSaving"
                        background-color="#006438"
                        :is-disabled="formDisabled"
                        @saveForm="saveForm"
                    />
                </b-col>
            </b-form-row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';
// import LocalApplicationModule from '$Components/LocalApplicationModule';

const storeModuleName = 'improvementPlan';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'ImprovementPlan',

    // components: {
    //     LocalApplicationModule,
    // },

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            coreIndicatorTable: [
                { key: 'indicatorDisplayName', label: 'Core Indicator' },
                { key: 'priorPerformance', label: 'Prior Performance' },
                { key: 'target', label: 'Target' },
                { key: 'improvementPlanYear', label: 'Improvement Plan Status' },
            ],

            isSaving: false,
            moduleTitle: 'Improvement Plan Status',
            nextModule: { name: 'localApplication.Section134Instructions' },
            // previousModule: { name: 'localApplication.AdministrativeFunds' },
            previousModule: { name: 'localApplication.Clusters' },
        };
    },

    computed: {
        ...mapState('ref/perkinsIndicators', {
            perkinsIndicatorPerformance: 'perkinsPerformanceWithIndicatorDetails',
        }),

        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState,
            applicantId: (state) => state.localApplicationData.applicantId,
            localapplicationAy: (state) => state.localApplicationData.academicYear,
            // targetsDataContent: (state) => state.module.baselineAndTargets.data.content,
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            isReviewer: 'auth/isReviewer',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`,
        }),

        targetAy() {
            return (Number(this.localapplicationAy));
        },

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        explanation1P1Disabled() {
            let disable = true;
            this.perkinsIndicatorPerformance.forEach((indi) => {
                if (indi.indicator === '1P1') {
                    if (indi.improvementPlanYear > 0) {
                        disable = false;
                    }
                }
            });
            return disable;
        },

        explanation2P1Disabled() {
            let disable = true;
            this.perkinsIndicatorPerformance.forEach((indi) => {
                if (indi.indicator === '2P1') {
                    if (indi.improvementPlanYear > 0) {
                        disable = false;
                    }
                }
            });
            return disable;
        },

        explanation3P1Disabled() {
            let disable = true;
            this.perkinsIndicatorPerformance.forEach((indi) => {
                if (indi.indicator === '3P1') {
                    if (indi.improvementPlanYear > 0) {
                        disable = false;
                    }
                }
            });
            return disable;
        },

        applicationPerkinsPerformance() {
            if (this.isReviewer) {
                return this.perkinsIndicatorPerformance.filter((indicator) => {
                    return indicator.applicantId === this.applicantId;
                });
            }

            return this.perkinsIndicatorPerformance;
        },

        explanation1P1: {
            get() { return this.localApplicationModuleContent.explanation1P1; },
            set(v) { this.updateExplanation1P1(v); }
        },

        explanation2P1: {
            get() { return this.localApplicationModuleContent.explanation2P1; },
            set(v) { this.updateExplanation2P1(v); }
        },

        explanation3P1: {
            get() { return this.localApplicationModuleContent.explanation3P1; },
            set(v) { this.updateExplanation3P1(v); }
        },
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}/`, {
            saveLocalApplicationModule: 'save',
            updateExplanation1P1: 'updateExplanation1P1',
            updateExplanation2P1: 'updateExplanation2P1',
            updateExplanation3P1: 'updateExplanation3P1',
        }),

        blurCheck($event) {
            // TODO: Rudimentary validation for percentages on idicator targets. Extract to vee-validate etc.
            // TODO: Move to store, if possible
            // TODO: Fetching/mapping validation from API might be a better approach
            $event.target.reportValidity();
        },

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                console.log(error);
                this.isSaving = false;
            }
        },
    },
};
</script>
